import { Injectable } from "@angular/core";
import { NonTestableDevices } from "@foundation/foundation.enums";
import { IManualValidationCheckCategory } from "@foundation/foundation.interfaces";

export enum ManualTests {
    DvsAlarm,
    DvsNearsideCamera,
    LightsWork,
    SpinningTest
}
@Injectable()
export class ManualDeviceValidationCheckService {


    createPeripheralTestCategories(peripheralType: NonTestableDevices): IManualValidationCheckCategory {
        switch (peripheralType) {
            case NonTestableDevices.DVS:
                return {
                    name: "DVS Validation", section: NonTestableDevices.DVS ,checks: [
                        { name: "DVS Alarm", assertion: "Does the alarm sound when left turn initiated?", test: ManualTests.DvsAlarm },
                        { name: "DVS Nearside Camera", assertion: "Does the Nearside camera show when left turn initiated?", test: ManualTests.DvsNearsideCamera }]
                }
            case NonTestableDevices.Transcan:
                return {
                    name: "Transcan Validation", section: NonTestableDevices.Transcan, checks: [
                        { name: "Lights Work", assertion: "Do the Lights flash?", test: ManualTests.LightsWork },
                        { name: "Spinning Test", assertion: "Does the unit spin like it's being dragged into a hellish vortex?", test: ManualTests.SpinningTest }
                    ]
                }
            default:
                return;
        }
    }
}
